import React, {Component, PropTypes} from 'react';
import './inline-warning.scss';

export class InlineWarningList extends Component {
  render() {
    const { show, warningMain, warningList } = this.props;
    var count = -1;
    var listDisplay = (
      warningList.map( function(warning) {
        count++;
        return (
          <li key={count} role="presentation">
            { warning }
          </li>
        );
      })
    );
    return show ? (
      <ul role="alert" className="alert alert-warning warning-list" aria-live="assertive">
        { warningMain }
        { listDisplay }
      </ul>
    ) : null;
  }
}

InlineWarningList.propTypes = {
  warningMain: PropTypes.string,
  warningList: PropTypes.array
};

export default InlineWarningList;



// WEBPACK FOOTER //
// src/common/inline-warning-list.js